import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  GATEWAY_COMMISSIONING_DEVICE,
  GATEWAY_COMMISSIONING_FLOW,
  GATEWAY_COMMISSIONING_STEP,
  GatewayCommissioningStore,
} from '@store';

@Component({
  selector: 'app-installation-type-select',
  templateUrl: './installation-type-select.component.html',
  styleUrls: ['./installation-type-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationTypeSelectComponent {
  readonly deviceType = GATEWAY_COMMISSIONING_DEVICE;
  readonly commissioningFlow = GATEWAY_COMMISSIONING_FLOW;

  constructor(private gatewayCommissioningStore: GatewayCommissioningStore) {}

  nextStepClicked(
    selectedDevice: GATEWAY_COMMISSIONING_DEVICE,
    commissioningFlow: GATEWAY_COMMISSIONING_FLOW
  ): void {
    this.gatewayCommissioningStore.setActiveStep({
      activeStep: GATEWAY_COMMISSIONING_STEP.INSTRUCTIONS,
    });
    this.gatewayCommissioningStore.setSelectedDevice(selectedDevice);
    this.gatewayCommissioningStore.setCommissioningFlow(commissioningFlow);
  }
}
